import 'tachyons'
import 'styling/semantic.less'
import 'styling/style.css'

import React, { Component } from 'react'
import axios from 'axios'
import _ from 'lodash';
import moment from 'moment';
import { Loader, Container, Segment, Grid, Input, Message, Pagination, Dropdown, Button, Responsive, Divider } from 'semantic-ui-react';
import 'react-day-picker/lib/style.css';
import DayPickerInput from 'react-day-picker/DayPickerInput';

import InmateGridItem from './components/InmateGridItem';
import InmateDetailModal from './components/InmateDetailModal';
import HeaderMenu from './components/Menu';

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loader: true,
            dimmer: 'blurring',
            searchInput: '',
            inmates: [],
            selectedInmate: null,
            activePage: 1,
            totalPages: 1,
            genderList: [],
            raceList: [],
            skip: '',
            race: '',
            gender: '',
            startDate: '',
            endDate: '',
            sortBy: 'bookingDate'
        };
    }

    componentDidMount() {
        axios.get(`${process.env.REACT_APP_API_URL}/inmates/get/genders-races`)
        .then((response) => {
            const genders = response.data.genders.map((e) => {
                return { key: e, text: e, value: e.toUpperCase() }
            });

            const races = response.data.races.map((e) => {
                return { key: e, text: e, value: e.toUpperCase() }
            });

            this.setState({ genderList: genders, raceList: races });

        }).catch((error) => {
            console.log(error);
        });

        this.fetchInmateDataFromApi();
    }

    fetchInmateDataFromApi = () => {
        const gender = this.state.gender ? `&gender=${this.state.gender}` : '';
        const race = this.state.race ? `&race=${this.state.race}` : '';
        const search = this.state.searchInput ? `&search=${this.state.searchInput}` : '';
        const skip = this.state.skip ? `&$skip=${this.state.skip}` : '';
        const startDate = this.state.startDate ? `&start=${this.state.startDate}` : '';
        const endDate = this.state.endDate ? `&end=${this.state.endDate}` : '';
        let sort = `$sort[BookingDate]=-1`;
        if(this.state.sortBy == 'name') {
            sort = `$sort[LastName]=1&$sort[FirstName]=1`;
        }

        axios.get(`${process.env.REACT_APP_API_URL}/inmates?$limit=30&${sort}${search}${skip}${gender}${race}${startDate}${endDate}`)
        .then((response) => {
            this.setState({
                inmates: response.data.data,
                loader: false,
                totalPages: Math.ceil(response.data.total/30)
            });
        }).catch((error) => {
            if (error.response) {
                console.log(error.response);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log(error);
            }
        }).then(() => {});
    }

    _onSearchInputChange = (evt) => {
        this.setState({ searchInput: evt.target.value, skip: '' }, this._serachInmates);
    }
    
    _serachInmates() {
        if (this.state.searchInput === '') this.fetchInmateDataFromApi();
        else if (this.state.searchInput.length > 3) {
            this.fetchInmateDataFromApi();
        }
    }

    showInmateDetailModal = (inmate) => {
        this.setState({ loader: true }, () => {
            this.setState({
                loader: false,
                selectedInmate: inmate
            })
        });
    }
    
    modalOnClose = () => {
        this.setState({
            loader: false,
            selectedInmate: null
        });
    }

    handlePaginationChange = (e, { activePage }) => {
        this.setState({
            loader: true,
            activePage: activePage,
            skip: (activePage-1) * 30
        }, this.fetchInmateDataFromApi);
    }

    handleGenderSelect = (e, { value }) => {
        this.setState({
            gender: value,
            activePage: 1,
            totalPages: 1,
            skip: '' 
        }, this.fetchInmateDataFromApi);
    }

    handleRaceSelect = (e, { value }) => {
        this.setState({
            race: value,
            activePage: 1,
            totalPages: 1,
            skip: ''
        }, this.fetchInmateDataFromApi);
    }

    setStartDate = (date) => {
        this.setState({ startDate: moment(date).format('MM/DD/YYYY') }, this.fetchInmateDataFromApi);
    }

    setEndDate = (date) => {
        this.setState({ endDate: moment(date).format('MM/DD/YYYY') }, this.fetchInmateDataFromApi);
    }

    resetFilter = () => {
        this.setState({
            race: '',
            gender: '',
            searchInput: '',
            activePage: 1,
            totalPages: 1,
            skip: '',
            startDate: '',
            endDate: ''
        }, this.fetchInmateDataFromApi)
    }

    render() {
        const itemsToRender = [];
        this.state.inmates.map((inmate, i) => {
            itemsToRender.push( <InmateGridItem key={i} inmate={inmate} onClick={this.showInmateDetailModal}/> );
        });

        return(
            <div className="ui padded grid">
                <Responsive minWidth={768}> <HeaderMenu/> </Responsive>

                <Loader active={this.state.loader} size='large'>Loading</Loader>

                <InmateDetailModal inmate={this.state.selectedInmate} dimmer={this.state.dimmer} onClose={this.modalOnClose} />

                <Container style={{ marginTop: '75px', width:'1300px' }}>
                    {this.state.loader == false &&
                    <div>
                        <Segment>
                            <Grid stackable columns={6} >
                                <Grid.Row>
                                    <Grid.Column>
                                        <Input style={{ width:'100%' }}
                                            value={this.state.searchInput}
                                            onChange={this._onSearchInputChange}
                                            icon='users'
                                            iconPosition='left'
                                            placeholder='Search inmates...' />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Dropdown
                                            placeholder='Gender'
                                            selection style={{ width:'100%' }}
                                            onChange={this.handleGenderSelect}
                                            value={this.state.gender}
                                            options={this.state.genderList}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Dropdown placeholder='Race'
                                            selection style={{ width:'100%' }}
                                            onChange={this.handleRaceSelect}
                                            value={this.state.race}
                                            options={this.state.raceList} 
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <DayPickerInput
                                            onDayChange={ this.setStartDate }
                                            value={this.state.startDate}
                                            placeholder="MM/DD/YYYY"
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <DayPickerInput 
                                            onDayChange={ this.setEndDate }
                                            value={this.state.endDate}
                                            placeholder="MM/DD/YYYY"
                                        />
                                    </Grid.Column>  
                                    <Grid.Column>
                                        <Button onClick={this.resetFilter} content='Reset'/>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Segment>
                        <Divider hidden/>
                        <Grid stackable columns={2}>
                            <Grid.Column style={{textAlign:'left'}}>
                                <Pagination
                                    style={{ marginBottom: '20px' }} activePage={this.state.activePage}
                                    onPageChange={this.handlePaginationChange} totalPages={this.state.totalPages}
                                    siblingRange={0} firstItem= {null} lastItem= {null}
                                />
                            </Grid.Column>
                            <Grid.Column style={{textAlign:'left'}}>
                                <Button.Group>
                                    <Button active={this.state.sortBy == 'bookingDate' ? true : false} onClick={() => this.setState({ sortBy: 'bookingDate', loader: true}, this._serachInmates)}>Sort by Booking Date</Button>
                                    <Button.Or />
                                    <Button active={this.state.sortBy == 'name' ? true : false} onClick={() => this.setState({ sortBy: 'name', loader: true}, this._serachInmates)}>Sort by Name</Button>
                                </Button.Group>
                            </Grid.Column>
                        </Grid>
                        <Segment>
                            <Message>
                                <Message.Header>Current Inmate Roster</Message.Header>
                            </Message>
                            {this.state.inmates.length > 0 &&
                                <Grid stackable columns={3} >
                                    {itemsToRender}
                                </Grid>
                            }
                            {this.state.inmates.length == 0 &&
                                <Message negative>
                                    <Message.Header>We're sorry we can't find any inmates</Message.Header>
                                    <p>No inmates found</p>
                                </Message>
                            }
                        </Segment>
                        <Grid.Column>
                            <Pagination
                                style={{ marginBottom: '20px' }}
                                activePage={this.state.activePage}
                                onPageChange={this.handlePaginationChange}
                                totalPages={this.state.totalPages}
                                siblingRange={0}
                                firstItem= {null}
                                lastItem= {null}
                            />
                        </Grid.Column>
                    </div>
                    }
                </Container>
            </div>
        )
    }
} 

export default App



// WEBPACK FOOTER //
// ./src/App.js